var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col w-5/6 ml-auto mr-auto"},[_c('span',[_c('h4',{staticClass:"mb-5"},[_vm._v("Sales Price Detail")])])])
}]

export { render, staticRenderFns }